// extracted by mini-css-extract-plugin
var _1 = "NotificationContent-module__animateUploadProgressBarWidth--BfClW";
var _2 = "NotificationContent-module__animatedBackground--Ig2f9";
var _3 = "NotificationContent-module__emptyState--TABGo";
var _4 = "NotificationContent-module__sectionHeader--QBaYP";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "emptyState", _4 as "sectionHeader" }
